import { CommanderThunkDispatch } from '@mews-commander/types';
import { NewRelicEventType } from '@mews/enums';
import { GainsightService } from '@mews/framework';
import { anonymizeUrl } from '@mews-commander/utils';
import { trackPageView } from '../../../middleware';
import { reportNewRelicEvents } from './newRelic';

export const navigationOccurred = ({
    dispatch,
    gainsightService,
    url,
}: {
    dispatch: CommanderThunkDispatch;
    gainsightService: GainsightService;
    url: string;
}) => {
    const anonymizedUrl = anonymizeUrl(url);

    dispatch(trackPageView({ url: anonymizedUrl }));
    gainsightService.trackPageView({ url: anonymizedUrl });
    dispatch(reportNewRelicEvents([{ eventType: NewRelicEventType.CustomPageView }]));
};
